import 'bootstrap/js/dist/collapse';



// WEBPACK FOOTER //
// ./scripts/autoload/_bootstrap.js